export const SUPPORT_UNAVAILABLE_MESSAGE = 'Customer support chat is unavailable right now. Please try again or email support@hubstaff.com.';

export function openPaymentSupportChat() {
  if (!window.zoomCampaignSdk && !document.querySelector('script[src*="/web-sdk/zcc-sdk.js"]')) {
    return Promise.reject(new Error(SUPPORT_UNAVAILABLE_MESSAGE));
  }

  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (error) => {
      if (settled) { return; }
      settled = true;
      clearTimeout(timeout);
      window.removeEventListener('zoomCampaignSdk:ready', open);
      if (error) { reject(error); } else { resolve(); }
    };

    const open = async () => {
      try {
        const sdk = window.zoomCampaignSdk;

        await sdk.waitForReady?.();
        if (settled) { return; }
        sdk.open();
        finish();
      } catch (error) {
        finish(error);
      }
    };

    const timeout = setTimeout(() => finish(new Error(SUPPORT_UNAVAILABLE_MESSAGE)), 10000);

    if (window.zoomCampaignSdk) {
      open();
    } else {
      window.addEventListener('zoomCampaignSdk:ready', open, { once: true });
    }
  });
}
